export class PaidTimeOffExport {
    groupName: string;
    name: string;
    august: number;
    september: number;
    october: number;
    november: number;
    december: number;
    january: number;
    february: number;
    march: number;
    april: number;
    may: number;
    june: number;
    july: number;
    yearDaysUsed: number;
}
